import { Inject } from '@odinjs/odin';
import BaseController from '../../BaseController';
import Controller, { OnBeforeSubmit, OnCancel, OnChange, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { CpotPainScaleAliases, FragmentNames } from '../../../codegen';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import './cpot-pain-scale-controller.css';

@Controller({ fragment: FragmentNames.CPOT_PAIN_SCALE })
class CpotPainScaleController extends BaseController {

  @Inject(CpotPainScaleAliases.FACIAL_EXPRESSION_RG)
  private facialExpressionRadioGroupApi!: RadioGroupAPI;

  @Inject(CpotPainScaleAliases.MUSCLE_TENSION_RG)
  private muscleTensionRadioGroupApi!: RadioGroupAPI;

  @Inject(CpotPainScaleAliases.EXTUBATED_PATIENTS_RG)
  private extubatedPatientsRadioGroupApi!: RadioGroupAPI;

  @Inject(CpotPainScaleAliases.BODY_MOVIMENTS_RG)
  private bodyMovimentsRadioGroupApi!: RadioGroupAPI;

  @Inject(CpotPainScaleAliases.RESPIRATOR_SUITABILITY_RG)
  private respiratorSuitabilityRadioGroupApi!: RadioGroupAPI;

  @Inject(CpotPainScaleAliases.CPOT_REFERENCE_PANEL)
  private referencePanelWithModalApi!: PanelAPI;

  @OnMount(CpotPainScaleAliases.FACIAL_EXPRESSION_RG)
  onMontExpressionFacialRedioGroup(event: MountEvent): void {
    this.fetchPainRadioGroup(335946, event.target as RadioGroupAPI);
  }

  @OnMount(CpotPainScaleAliases.MUSCLE_TENSION_RG)
  onMountMuscleTensionRadioGroup(event: MountEvent): void {
    this.fetchPainRadioGroup(335943, event.target as RadioGroupAPI);
  }

  @OnMount(CpotPainScaleAliases.EXTUBATED_PATIENTS_RG)
  onMountExtubatedPatientsnRadioGroup(event: MountEvent): void {
    this.fetchPainRadioGroup(335945, event.target as RadioGroupAPI);
  }

  @OnMount(CpotPainScaleAliases.BODY_MOVIMENTS_RG)
  onMountBodyMovimentsRadioGroup(event: MountEvent): void {
    this.fetchPainRadioGroup(335947, event.target as RadioGroupAPI);
  }

  @OnMount(CpotPainScaleAliases.RESPIRATOR_SUITABILITY_RG)
  onMountRespiratorSuitabilityRadioGroup(event: MountEvent): void {
    this.fetchPainRadioGroup(335944, event.target as RadioGroupAPI);
  }

  @OnClick(CpotPainScaleAliases.CPOT_REFERENCE_LINK)
  onClickReference(): void {
    this.referencePanelWithModalApi.setVisible(true);
  }

  @OnClose(CpotPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE)
  onCloseModalReference(): void {
    this.referencePanelWithModalApi.setVisible(false);
  }

  @OnCancel(CpotPainScaleAliases.CPOT_SCALE_FORM)
  onClickCancel(): void {
    ModalService.close(FragmentNames.CPOT_PAIN_SCALE);
  }

  @OnBeforeSubmit(CpotPainScaleAliases.CPOT_SCALE_FORM)
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.facialExpressionRadioGroupApi?.getValue()?.value)
                    + Number(this.muscleTensionRadioGroupApi.getValue()?.value)
                    + Number(this.extubatedPatientsRadioGroupApi.getValue()?.value)
                    + Number(this.bodyMovimentsRadioGroupApi.getValue()?.value)
                    + Number(this.respiratorSuitabilityRadioGroupApi.getValue()?.value));

    ModalService.close(FragmentNames.CPOT_PAIN_SCALE);
  }

  @OnChange({ target: [CpotPainScaleAliases.EXTUBATED_PATIENTS_RG, CpotPainScaleAliases.RESPIRATOR_SUITABILITY_RG] })
  handleChangeExtubatedRespiratorRg(event: ChangeEvent<RadioGroupAPI>): void {
    const radioGroup         = event.target as unknown as RadioGroupAPI;
    const radioGroupValue    = event.value as unknown as SelectableItem;
    const defaultEnabledItem = 0;
    const isEnabled          = Number(radioGroupValue.value) === defaultEnabledItem;

    switch (radioGroup.getAlias()) {
      case CpotPainScaleAliases.EXTUBATED_PATIENTS_RG:
        this.respiratorSuitabilityRadioGroupApi.setEnabled(isEnabled);
        break;
      case CpotPainScaleAliases.RESPIRATOR_SUITABILITY_RG:
        this.extubatedPatientsRadioGroupApi.setEnabled(isEnabled);
        break;
      default:
        break;
    }
  }

  fetchPainRadioGroup(expressionId: number, radioGroup: RadioGroupAPI): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, { encounterId, expressionId, patientId })
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }
}

export default CpotPainScaleController;
